export enum UserStatus {
    Invited = 1,
    InvitationExpired = 2,
    Active = 3
}